module.exports = __webpack_public_path__ + "img/logo.bb15015b.png";